var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{clickIndicator : _vm.animate},style:(_vm.animationStyle),on:{"click":function($event){return _vm.onClick()}}},[_c('i',{class:_vm.collapsedStateClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }